import React, { useMemo } from 'react';
import NewCrudButton from 'mrf/view/NewCrudButton';
import PageTitle from 'mrf/view/Title';
import QueryObjectTable from 'mrf/view/QueryObjectTable';
import Flex from 'mrf/layout/Flex';
import IF from './IF';
import pluralize from 'pluralize';
import ViewButton from './ViewButton';
import IFAuth from './IFAuth';
import EditButton from './EditButton';
import capitalize from 'mrf/utils/capitalize';

export default function ListCRUD({
    singular,
    actions,
    title,
    newButtonLabel,
    resource,
    fields,
    match,
    disableNewButton,
    disableViewButton,
    disableEditButton,
    canNew = [],
    canView = [],
    canEdit = [],
    movable=false,
    marginTop='2',
    ...queryObjectTableProps
}) {
    newButtonLabel = useMemo(
        () => {
            if (newButtonLabel || !singular) {
                return newButtonLabel
            }

            const tokens = singular.split(/(?=[A-Z])/);
            return 'New ' + tokens.map(capitalize).join(' ');
        },
        [newButtonLabel, singular]
    );

    title = useMemo(
        () => {
            if (title || !singular) {
                return title;
            }

            const tokens = singular.split(/(?=[A-Z])/);
            tokens.push(pluralize(tokens.pop()));
            return tokens.map(capitalize).join(' ');
        },
        [title, singular]
    );

    resource = useMemo(
        () => {
            if (resource || !singular) {
                return resource;
            }

            return pluralize(singular);
        },
        [resource, singular]
    );

    fields = [
        ...fields,
        {
            align: 'right', map: ({ id }) => (<>
                <IFAuth
                    condition={!disableViewButton}
                    roleCodes={canView}
                >
                    <ViewButton match={match} id={id} />
                </IFAuth>
                <IFAuth
                    condition={!disableEditButton}
                    roleCodes={canEdit}
                >
                    <EditButton match={match} id={id} />
                </IFAuth>
            </>)
        },
    ]

    return <Flex direction='col' className='p-4 min-w-fit'>
        <PageTitle>{title}</PageTitle>
        <QueryObjectTable
            resource={resource}
            fields={fields}
            movable={movable}
            {...queryObjectTableProps}
        />
        <Flex justify='end'>
            <IF condition={!!actions}>
                {actions}
            </IF>
            <IFAuth
                condition={!disableNewButton}
                roleCodes={canNew}
            >
                <NewCrudButton marginTop={marginTop}
                    match={match}
                    label={newButtonLabel || `New ${title}`}
                />
            </IFAuth>
        </Flex>
    </Flex>;
}
